import { format } from "d3-format";
import React, { Component } from "react";
import PropTypes from "prop-types";

import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor } from "../utils";

class RVITooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const { onClick, fontFamily, fontSize, displayFormat, className } =
      this.props;
    const { yAccessor, options, appearance, labelFill } = this.props;
    const { displayValuesFor } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);
    const rviValue = currentItem && yAccessor(currentItem);

    const rvi =
      (rviValue && rviValue.rvi && displayFormat(rviValue.rvi)) || "n/a";
    const signal =
      (rviValue && rviValue.signal && displayFormat(rviValue.signal)) || "n/a";
    const histogram =
      (rviValue && rviValue.histogram && displayFormat(rviValue.histogram)) ||
      "n/a";

    // Safe access to appearance properties with fallback colors
    const rviColor = appearance?.strokeMACD?.color || "#AAAAAA";
    const signalColor = appearance?.strokeSignal?.color || "#FF0000";
    const histogramColor = appearance?.barDivergence?.color || "#00DD00";

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-rvi"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>RVI (</ToolTipTSpanLabel>
          <tspan fill={rviColor}>{options.period}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>): </ToolTipTSpanLabel>
          <tspan fill={rviColor}>{rvi}</tspan>
          <ToolTipTSpanLabel fill={labelFill}> Signal: </ToolTipTSpanLabel>
          <tspan fill={signalColor}>{signal}</tspan>
          <ToolTipTSpanLabel fill={labelFill}> Hist: </ToolTipTSpanLabel>
          <tspan fill={histogramColor}>{histogram}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

RVITooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  className: PropTypes.string,

  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  displayFormat: PropTypes.func,
  displayValuesFor: PropTypes.func,

  onClick: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  options: PropTypes.shape({
    period: PropTypes.number.isRequired,
  }).isRequired,
  appearance: PropTypes.shape({
    strokeMACD: PropTypes.object,
    strokeSignal: PropTypes.object,
    barDivergence: PropTypes.object,
  }),
  labelFill: PropTypes.string,
};

RVITooltip.defaultProps = {
  origin: [0, 0],
  className: "react-stockcharts-tooltip react-stockcharts-rvi-tooltip",
  displayFormat: format(".2f"),
  displayValuesFor,
  labelFill: "#4C525E",
};

export default RVITooltip;
